import React, {useEffect, useState, useRef, forwardRef} from 'react';
import "./Contacts.scss"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import {useAnimation, motion} from "framer-motion";
import {useTranslation} from "react-i18next";

const Contacts = ({ forwardedRef }) =>  {
	const { t, i18n } = useTranslation();
	const ref = useRef();
	const controls = useAnimation();

	// Intersection Observer Configuration
	const observerOptions = {
	  root: null,
	  rootMargin: '0px 0px',
	  threshold: 0.3
	};

	let easing = [0.6, -0.05, 0.01, 0.99];

	const stagger = {
		animate: {
			transition: {
				staggerChildren: 0.05
			}
		}
	};

	const fadeInUp = {
		initial: {
			y: 60,
			opacity: 0,
			transition: {duration: 0.6, ease: easing}
		},
		animate: {
			y: 0,
			opacity: 1,
			transition: {
				duration: 0.6,
				ease: easing
			}
		},
	};

    useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
		  entries.forEach(
			entry => {
				 if (entry.isIntersecting && entry.target.classList.contains("form__box")) {
					observerInstance.unobserve(ref.current);
					controls.start("animate")
				}
			}
		  );
      },
      observerOptions
    );
    if (ref.current) {
      observer.observe(ref.current);
    }
  }, [ref]);

    return (
        <motion.div className="contacts__container" ref={forwardedRef} variants={stagger}>
			<motion.div className="section__header--contacts" animate={controls} variants={fadeInUp} initial="initial">
				<div className="section__header--line blue"></div><h5 className="section__header--title blue">{t('contacts')}</h5>
			</motion.div>
			
			<motion.div className="form__box" ref={ref} animate={controls} variants={fadeInUp} initial="initial">
				<motion.h4 animate={controls} variants={fadeInUp} initial="initial">{t('contactUs')}</motion.h4>
				<motion.div className="inputs__box" animate={controls} variants={fadeInUp} initial="initial">
					<input className="form__input" placeholder="Nome" type="text"></input>
					<input className="form__input" placeholder="E-mail" type="email"></input>
					<textarea className="form__input textarea" rows="8" placeholder="Messaggio" style={{marginTop: 60}}></textarea>
				</motion.div>
				<motion.div className="btn__primary" style={{marginTop: 60}} animate={controls} variants={fadeInUp} initial="initial">
						<div className="btn__primary--background"></div>
						<div className="btn__primary--text">
						  <div>{t('send')}</div>
						</div>
				</motion.div>
				
			</motion.div>
			
			<div className="map"></div>
			
			<div className="contacts__box">
				<a className="a--address" target="_blank" href="https://www.google.com/maps/place/Piazza+Municipio,+62,+95032+Belpasso+CT/@37.5902936,14.9746048,17z/data=!3m1!4b1!4m5!3m4!1s0x1311568c53e2875b:0x241ef07729334091!8m2!3d37.5902936!4d14.9767935">
					<div className="contacts__box1">
						<h4>{t('address')}</h4>
						<div className="line__subtitle" style={{marginLeft: 5}}></div>
						<p className="contacts__text">Piazza Municipio, 62</p>
						<p className="contacts__text">95032 Belpasso (CT)</p>
						
						<div className="text__map">
							<p className="contacts__text">{t('italy')}</p><FontAwesomeIcon icon={faChevronRight} className="icon__map"/>
						</div>
					</div>
				</a>
				
				<div className="contacts__box2">
					<h4>{t('contacts')}</h4>
					<div className="line__subtitle" style={{marginLeft: 5}}></div>
					<a href="mailto:prova@hotmail.it"><p className="contacts__text contacts__item">prova@hotmail.it</p></a>
					<a href="tel:+39095101010"><p className="contacts__text contacts__item">+39 095 101010</p></a>
					<a href="tel:+39095101010"><p className="contacts__text contacts__item">+39 3331212123</p></a>
				</div>
			</div>
			
			
			
        </motion.div>
    );
}

export default Contacts;
